import {
  buildRoleByIdMap,
  formatRoleLevelFromRoleId,
} from '../../RoleAssignment/functions/format_role_level_display.function';

const toUserIdKey = (id) => (id == null || id === '' ? null : String(id));

export const buildUserByIdMap = (users) => {
  const map = new Map();
  if (!Array.isArray(users)) {
    return map;
  }
  users.forEach((user) => {
    const key = toUserIdKey(user?.id);
    if (key) {
      map.set(key, user);
    }
  });
  return map;
};

/**
 * Fills new/previous user display fields when the API returns only user ids
 * (lookup from getAllNonVendorUsers).
 */
export const enrichPendingRequestsWithUsers = (requests, users, roles = []) => {
  if (!Array.isArray(requests)) {
    return [];
  }
  const userById = buildUserByIdMap(users);
  const roleById = buildRoleByIdMap(roles);

  return requests.map((request) => {
    const user = userById.get(toUserIdKey(request.user_id));
    const previousUser = userById.get(toUserIdKey(request.previous_user_id));

    return {
      ...request,
      role_name: formatRoleLevelFromRoleId(request.role_name, request.role_id, roleById),
      user_name: request.user_name ?? user?.name ?? null,
      user_email: request.user_email ?? user?.email ?? null,
      user_region: request.user_region ?? user?.region ?? null,
      previous_user_name: request.previous_user_name ?? previousUser?.name ?? null,
      previous_user_email: request.previous_user_email ?? previousUser?.email ?? null,
    };
  });
};
